<template>
  <div :id="id" class="nt-menu">
    <div class="nt-menu__wrap-items">
      <div
        v-for="(item, index) in menus"
        :key="item.id"
        class="nt-menu__item"
        :class="{ active: subMenuActive === index }"
        @mouseover="onover(item, index)"
      >
        <a :href="item.LinkMenu" @click="pushDataLayer(item.Name)">{{ item.Name }}</a>

        <div v-if="item.Items.length > 0" class="nt-menu__icon-wrapper">
          <span
            @click="toggleSubMenu(index)"
            class="nt-menu__icon"
            :class="{ 'nt-menu__icon-top': isSubMenuActive && subMenuActive === index }"
          >
            <svg xmlns="http://www.w3.org/2000/svg" height="36" width="36">
              <path d="m24 30.75-12-12 2.15-2.15L24 26.5l9.85-9.85L36 18.8Z" />
            </svg>
          </span>
        </div>

        <ul
          v-if="item.Items.length > 0"
          class="nt-menu__submenu-wrapper"
          :class="{ 'nt-menu__submenu-wrapper--active': subMenuActive === index }"
        >
          <li v-for="subItem in item.Items" :key="subItem.id">
            <a :href="subItem.LinkMenu" @click="pushDataLayer(item.Name, subItem.Name)">{{
              subItem.Name
            }}</a>
          </li>
        </ul>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'nt-menu',
  props: {
    id: {
      type: String,
      default: 'menu',
    },
    menus: Array,
  },
  data() {
    return {
      isSubMenuActive: false,
      subMenuActive: -1,
    }
  },
  methods: {
    onover(event) {
      const arrow = this.$refs.arrow

      if (arrow instanceof HTMLElement) {
        const el = event.currentTarget

        arrow.style.left = `${el.offsetLeft}px`
        arrow.style.width = `${el.offsetWidth}px`
      }
    },
    toggleSubMenu(index) {
      this.subMenuActive = this.subMenuActive === index ? -1 : index
      this.isSubMenuActive = this.subMenuActive === index
    },
    pushDataLayer(name, suffix) {
      const label = suffix ? `${name} - ${suffix}` : name
      window.dataLayer.push({
        event: 'navigation',
        label,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.nt-menu {
  &__item {
    display: flex;
    flex-direction: column;
    position: relative;

    a, svg {
      &:hover, &:active, &:focus {
        color: #9ddda9;
        font-weight: 500;
        fill: #9ddda9;
      }
    }
  }

  &__icon {
    position: absolute;
    right: 10px;
    top: 0;

    &-top {
      -ms-transform: rotate(-180deg);
      -moz-transform: rotate(-180deg);
      -webkit-transform: rotate(-180deg);
      transform: rotate(-180deg);
      right: 0;
    }

    svg {
      fill: #3b3b3b;
      transition: fill 0.2s ease;
    }
  }

  &__submenu-wrapper {
    display: none;

    li {
      display: flex;
      justify-content: center;
      margin-bottom: 5px;
      width: 100%;
      transition: all 0.5s ease;

      a {
        text-decoration: none;
        font-size: 18px;
        color: #3b3b3b;
        font-weight: 300;
        padding: 5px 0;
        width: 100%;

        @media screen and (min-width: 744px) {
          font-size: 20px;
        }
      }
    }

    &--active {
      display: flex;
      flex-direction: column;
      text-align: center;

      a {
        &:hover, &:active, &:focus {
          font-weight: 600;
        }
      }
    }
  }
}
</style>
